import { xhr } from '@/api/config/Repository'
import OrderManagementRepository from '../OrderManagementRepository'
import OrderSearchRequestDTO from '@/services/orderManagement/models/OrderSearchRequestDTO'
import QualifierResponseDTO from '../dto/QualifierResponseDTOs'
import OrderStatusResponseDTO from '@/services/orderManagement/models/OrderStatusResponse'
import OrderSearchExportResponseDTO from '../dto/OrderSearchExportResponseDTO'
export default class OrderManagementRepositoryImpl implements OrderManagementRepository {
  async getOrderSearchData (paramData: OrderSearchRequestDTO): Promise<any> {
    const endpoint = 'order/fetchOrderSummary'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<OrderSearchRequestDTO, any>(endpoint, paramData, { headers })
    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getQualifierData (): Promise<any> {
    const endpoint = 'md/getQualifiers'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<QualifierResponseDTO[]>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getOrderStatusData (): Promise<any> {
    const endpoint = 'md/getAllOrderStatus'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<OrderStatusResponseDTO[]>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getTableExportData (paramData: any): Promise<OrderSearchExportResponseDTO> {
    const endpoint = 'order/exportOrderInfo'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    // const response = await xhr.get<any>(endpoint, { headers })
    const response = await xhr.post<OrderSearchExportResponseDTO, any>(endpoint, paramData, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async getOrderDetailsExportData (paramData: string): Promise<OrderSearchExportResponseDTO> {
    const endpoint = 'order/downloadOrderDetail/' + paramData
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<any>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }
}
